import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@devhop/ui";
import { PlusCircleIcon } from "lucide-react";
import {
  FORM_FIELD_TYPE_GROUPS,
  formFieldTypeIcon,
  formFieldTypeLabel,
} from "@/modules/forms/presentation/ui/builder/form-field-type-meta";
import type { FormFieldType } from "@/server/platform/db/schema/forms";

type AddFieldMenuProps = {
  disabled?: boolean;
  onAdd: (type: FormFieldType) => void;
};

export function AddFieldMenu({ disabled, onAdd }: AddFieldMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" disabled={disabled}>
          <PlusCircleIcon className="mr-2 h-4 w-4" aria-hidden />
          ເພີ່ມຄຳຖາມ
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        {FORM_FIELD_TYPE_GROUPS.map((group, groupIdx) => (
          <div key={group.id}>
            {groupIdx > 0 ? <DropdownMenuSeparator /> : null}
            <DropdownMenuLabel className="text-muted-foreground text-xs">
              {group.label}
            </DropdownMenuLabel>
            <DropdownMenuGroup>
              {group.types.map((type) => {
                const Icon = formFieldTypeIcon(type);
                return (
                  <DropdownMenuItem
                    key={type}
                    onClick={() => onAdd(type)}
                    className="cursor-pointer gap-2"
                  >
                    <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
                    <span className="flex-1">{formFieldTypeLabel(type)}</span>
                    <span className="text-muted-foreground text-xs">{type}</span>
                  </DropdownMenuItem>
                );
              })}
            </DropdownMenuGroup>
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
